module.exports = __webpack_public_path__ + "static/media/night_flight_4.9dd05299.jpg";